import { TRUSTPILOT_BUSINESS_UNIT_ID } from '@/utils/constants';

export default function TrustboxWidget() {
  if (!TRUSTPILOT_BUSINESS_UNIT_ID) return null;

  const sharedProps = {
    className: 'trustpilot-widget',
    'data-locale': 'de-DE',
    'data-template-id': '5419b6ffb0d04a076446a9af',
    'data-businessunit-id': TRUSTPILOT_BUSINESS_UNIT_ID,
    'data-style-height': '40px',
    'data-theme': 'light',
    'data-style-size': 'S',
    'data-text-color': 'dark',
    'data-headline': 'star',
    'data-support-text': 'review-number',
    'data-background': 'none',
    'data-external-elements-color': 'dark',
  };

  const link = (
    <a
      href="https://de.trustpilot.com/review/oviva.com"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Trustpilot-Bewertungen für Oviva"
    />
  );

  return (
    <>
      <div {...sharedProps} data-style-width="140px" className="trustpilot-widget md:hidden">
        {link}
      </div>
      <div {...sharedProps} data-style-width="260px" className="trustpilot-widget hidden md:block">
        {link}
      </div>
    </>
  );
}
